// extracted by mini-css-extract-plugin
export default {"container":"Board_container__pIXhe","button_create":"Board_button_create__B+-vo"};